import { tracker } from '@affine/track';
import { sendRouteChange } from '../../embed-mode';
import { createEvent, Service } from '@toeverything/infra';
import { combineLatest, distinctUntilChanged, map, skip } from 'rxjs';

import { Workbench } from '../entities/workbench';

export const WorkbenchLocationChanged = createEvent<string>(
  'WorkbenchLocationChanged'
);

export class WorkbenchService extends Service {
  constructor() {
    super();
    combineLatest([this.workbench.location$, this.workbench.basename$])
      .pipe(
        map(([location, basename]) => basename + location.pathname),
        distinctUntilChanged(),
        skip(1)
      )
      .subscribe(newLocation => {
        this.eventBus.root.emit(WorkbenchLocationChanged, newLocation);
        tracker.track_pageview({
          location: newLocation,
        });

        // Send route change to parent in embed mode
        if (environment.isEmbedMode) {
          sendRouteChange(newLocation, document.title);
        }
      });
  }

  workbench = this.framework.createEntity(Workbench);
}
